function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
/**
 * Calls `prop` if it's a function or just returns it otherwise.
 * Useful for optionally-callback props on React components.
 *
 * @param prop - a value that may or may not be a function
 * @param args - arguments to be passed to `prop` if it's a function
 * @return the result of `prop`(...`args`) if it's a function or `prop` otherwise
 */ export default function(prop) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    if (typeof prop === "function") return prop.apply(void 0, _toConsumableArray(args));
    return prop;
};
export var tryCallRenderProp = function(maybeRenderProp, param) {
    var defaultRender = param.defaultRender, props = param.props, shouldDefaultRender = param.shouldDefaultRender;
    if (!shouldDefaultRender) shouldDefaultRender = function() {
        return maybeRenderProp;
    };
    return typeof maybeRenderProp === "function" ? maybeRenderProp(props, defaultRender) : shouldDefaultRender() && (defaultRender === null || defaultRender === void 0 ? void 0 : defaultRender());
};
